import { motion } from 'framer-motion';

const OFFERS = [
  { icon: '🚚', text: 'Delivery charge only ₹60 — regardless of quantity' },
  { icon: '🎉', text: 'FREE SHIPPING on orders above ₹699' },
  { icon: '🎁', text: 'FREE poster on orders above ₹999' },
  { icon: '🔥', text: 'FREE split poster on orders above ₹1999' },
];

const OfferBar = () => {
  // Duplicate the offers for a seamless infinite scroll
  const items = [...OFFERS, ...OFFERS, ...OFFERS, ...OFFERS];

  return (
    <div
      className="fixed top-14 sm:top-16 left-0 right-0 z-40 bg-white text-black border-b border-black/10 overflow-hidden"
      data-testid="offer-bar"
    >
      <div className="relative flex">
        <motion.div
          className="flex shrink-0 items-center gap-12 whitespace-nowrap py-2 px-6"
          animate={{ x: ['0%', '-50%'] }}
          transition={{ duration: 40, ease: 'linear', repeat: Infinity }}
        >
          {items.map((offer, i) => (
            <div
              key={i}
              className="flex items-center gap-2 text-xs sm:text-sm font-medium tracking-wide"
            >
              <span className="text-base sm:text-lg" aria-hidden>
                {offer.icon}
              </span>
              <span>{offer.text}</span>
              <span className="opacity-40 mx-4">•</span>
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default OfferBar;
